import { useMutation } from "@tanstack/react-query";
import {
  UpdateApplicationParams,
  updateApplication,
} from "supabase/events/updateApplication";
import { queryClient } from "utils";

export const useUpdateApplication = (onSuccess?: () => void) => {
  const mutation = useMutation({
    mutationFn: (params: UpdateApplicationParams) => {
      return updateApplication(params);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["applications"],
      });
      queryClient.invalidateQueries({
        queryKey: ["application", variables.id],
      });

      if (onSuccess) {
        onSuccess();
      }
    },
  });

  return mutation;
};
